export const STRAPI_TOKEN =
  "Bearer 575da18677cc56000706bb3a34564cdea7bf9e869ac0536ce3034fe029f5a5c26d473b8c75bfd7fcfa053b6bdc01ef30b111b3334a0807288ef4db28e27d2f97a479792de674233efe49f0a37f66e20b76a562e93025223ef53864927fa55190b204f7350293ec19b2d63e8834b05ddfddea71273f8320b970a84566f07b5e54";
